// Assets
import OopsError from '@/assets/images/oops-error.png';
import { Button } from '@/components/ui/Button/Button';
import { Pages } from '@/utils/routes.utils';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  /* ******************************** RENDERING ******************************* */
  return (
    <div className='flex justify-center items-center flex-col'>
      <div className="mb-[30px]">
        <img src={OopsError} />
      </div>
      <p className='text-[30px] pb-3 text-center'>{t("notFound.title")}</p>
      <p className='text-center'>{t("notFound.subtitle_1")}</p>
      <p className='text-center mb-6'>{t("notFound.subtitle_2")}</p>
      <Button
        size='small'
        primary
        label={t("buttons.return")}
        onClick={() => {
          navigate(Pages.HOME)
        }}
      />
    </div>
  )
};
export default NotFound;
